"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var IconButtonTheme = function IconButtonTheme(colors) {
  return {
    styleOverrides: {
      root: {
        fontSize: '1rem',
        '&:hover': {
          backgroundColor: 'transparent'
        },
        '&.Mui-disabled': {
          color: colors.grey30
        }
      },
      sizeSmall: {
        padding: '3px',
        fontSize: '1rem'
      },
      sizeLarge: {
        fontSize: '1.5rem'
      }
    }
  };
};

var _default = IconButtonTheme;
exports["default"] = _default;